export const PLAN_CARD_INCLUDED_FEATURES = [
  'Push notifications',
  'Geofencing',
  'Bulk operations',
];

export const PLAN_CARD_HIDDEN_FEATURE_KEYS = ['entities'];

export const PLAN_FEATURES_CONFIG = [
  {
    key: 'seats',
    label: 'Seats',
    singularLabel: 'Seat',
    type: 'number',
  },
  {
    key: 'passes',
    label: 'Passes',
    singularLabel: 'Pass',
    type: 'number',
  },
  {
    key: 'entities',
    label: 'Entities',
    singularLabel: 'Entity',
    type: 'number',
  },
  {
    key: 'pass_templates',
    label: 'Pass Templates',
    singularLabel: 'Pass Template',
    type: 'number',
  },
  {
    key: 'passentry_reader_logins',
    label: 'Reader Logins',
    singularLabel: 'Reader Login',
    type: 'number',
  },
  {
    key: 'localisation',
    label: 'Multi-language support',
    type: 'boolean',
  },
  {
    key: 'passentry_watermark',
    label: 'Watermark removal',
    type: 'boolean',
  },
  {
    key: 'pass_binding',
    label: 'Pass Binding',
    type: 'boolean',
  },
  {
    key: 'sso',
    label: 'Single Sign-On (SSO)',
    type: 'boolean',
  },
];

export const findFeatureByKey = (features, key) => {
  if (!features || !Array.isArray(features)) return null;
  return features.find((f) => f.key === key);
};

export const formatFeatureValue = (feature, config) => {
  if (!feature) return config.label;

  if (config.type === 'number') {
    const value = feature.limit;
    if (value === 1 && config.singularLabel) {
      return `${value} ${config.singularLabel}`;
    }
    return `${value?.toLocaleString() ?? 0} ${config.label}`;
  }

  if (config.type === 'boolean') {
    if (config.key === 'passentry_watermark') {
      return config.label;
    }
    return config.label;
  }

  return feature.name || config.label;
};

export const hasFeatureValue = (feature, config) => {
  if (!feature) return false;

  if (config.type === 'boolean') {
    if (config.key === 'passentry_watermark') {
      return feature.access === false;
    }
    return feature.access === true;
  }

  return feature.limit !== undefined && feature.limit !== null;
};
